import config from '../config';
import { PzptApiOptions } from './PzptApiOptions';
import { PzptApi } from './createPzptRequest';
import { BaseResponse } from './shared';

export interface TextData {
  configCode: string;
  type: number; //0-h5, 1-rn
  content: string;
}

interface QueryTextByCodeRequest {
  code: string;
}

interface QueryTextByCodeResponse extends BaseResponse {
  data: TextData;
}

/**
 * 根据配置编码查询富文本
 * @param params
 * @returns
 */
export async function queryTextByCode(request: QueryTextByCodeRequest, options?: PzptApiOptions) {
  const url = config.pzptLink + '/api/contest/getText';
  return PzptApi.fetch<QueryTextByCodeResponse>(url, request, options);
}
